<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.StorePopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="StorePopup"
      class="store-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="main">
        <wh-field-time-popup
          v-model="form.warehousingTime"
          :rules="rules.warehousingTime"
          input-align="left"
          label="操作时间"
        />
        <van-field v-model="form.materialName" :rules="rules.materialName" label="原料名称" placeholder="请输入原料名称" />
        <wh-popup-select v-model="form.productStandards" :rules="rules.productStandards" :columns="StandardsList" label="产品标准" placeholder="请选择产品标准" />
        <div class="wh-flex-between">
          <van-field v-model.number="form.recordsQuantity" style="width: 100%;" :rules="rules.recordsQuantity" label="数量" placeholder="请输入数量" />
          <wh-popup-select
            v-model="form.materialUnit"
            style="width: 100px;flex-shrink: 0"
            :rules="rules.materialUnit"
            :columns="unitOptionsColumns"
            placeholder="单位"
          />
        </div>
        <van-field v-model="form.supplier" label="供应商" :rules="rules.supplier" placeholder="请输入供应商" />
        <wh-staff v-model="form.staffName" :rules="rules.staffName" placeholder="请选择负责人" lable="负责人" />
      </div>
    </van-form>
  </wh-popup>
</template>
<script>
import api from '@/api'
import { formatTime } from '@/utils/convert/convertTime'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formPopup } from '@/utils/mixins/formPopup'
import WhStaff from '@/components/public/WhStaff/WhStaff'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import { unitOptions } from '@/constant/common'

export default {
  components: { WhPopup, WhStaff, WhPopupSelect, WhFieldTimePopup },
  mixins: [formPopup],
  data() {
    return {
      unitOptionsColumns: unitOptions.map(item => {
        return {
          value: item,
          text: item
        }
      }),
      rules: {
        warehousingTime: [{ required: true, trigger: 'onBlur', message: '请选择操作时间' }],
        materialName: [{ required: true, message: '请输入原料名称' }],
        recordsQuantity: [{ required: true, validator: val => val >= 0, message: '请输入数量' }],
        supplier: [{ required: true, message: '请输入供应商' }],
        staffName: [{ required: true, trigger: 'onChange', message: '请选择负责人' }],
        materialUnit: [{ required: true, trigger: 'onChange', message: '选择单位' }]
      },
      form: {
        id: undefined,
        warehousingTime: this.formatTime(new Date(), 'YYYY-MM-DD HH:mm'),
        materialName: '',
        productStandards: '',
        recordsQuantity: '',
        supplier: undefined,
        stockId: undefined,
        staffName: '',
        materialUnit: undefined
      },
      StandardsList: [
        {
          text: '普通农产品', value: '普通农产品'
        },
        {
          text: '绿色农产品', value: '绿色农产品'

        },
        {
          text: '有机农产品', value: '有机农产品'
        }
      ]
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '添加原料' : '编辑原料'
    }
  },
  watch: {
    visible: {
      handler(newV) {
        this.$nextTick(() => {
          this.$refs.StorePopup.resetValidation()
        })
      }
    }
  },
  methods: {
    formatTime,
    open() {
      if (this.formType === 'create') {
        this.formDataInit(this.form)
      } else {
        this.initFormData.operatingTime = formatTime(this.initFormData.operatingTime, 'YYYY-MM-DD HH:mm:00')
        this.formDataInit(this.form, this.initFormData)
      }
    },
    submitForm() {
      if (this.form.id) {
        const editform = {
          ...this.form,
          warehousingTime: this.formatTime(this.form.warehousingTime, 'YYYY-MM-DD HH:mm:00')
        }
        api.updateRawMaterialsStock(editform).then(() => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      } else {
        const createform = {
          ...this.form,
          warehousingTime: this.formatTime(this.form.warehousingTime, 'YYYY-MM-DD HH:mm:00')
        }
        api.createRawMaterialsStock(createform).then(res => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>
